// // Imports
// import { CommonModule } from '@angular/common';
// import { Component, OnDestroy, OnInit } from '@angular/core';
// import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { MatDialog } from '@angular/material/dialog';
// import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
// import { Subject, Subscription, filter, takeUntil } from 'rxjs';
// import { AppConfig } from './config/service.config';
// import { DialogIdleComponent } from './modules/auth/dialog-idle/dialog-idle.component';
// import { IdleService } from './modules/auth/dialog-idle/idle.service';

// @Component({
//     selector: 'app-root',
//     templateUrl: './app.component.html',
//     styleUrls: ['./app.component.scss'],
//     standalone: true,
//     imports: [RouterOutlet, CommonModule, FormsModule, ReactiveFormsModule],
// })
// export class AppComponent implements OnInit, OnDestroy {
//     // -----------------------------------------------------------------------------------------------------
//     // @ Private methods
//     // -----------------------------------------------------------------------------------------------------

//     private _unsubscribeAll: Subject<any> = new Subject<any>();
//     // For idle service, to detect inactivity.
//     private idleSubscription?: Subscription;
//     // For dialog pop up.
//     private dialogRef: any;

//     isDisplay: boolean = true;

//     // -----------------------------------------------------------------------------------------------------
//     // @ Constructor
//     // -----------------------------------------------------------------------------------------------------

//     constructor(
//         private idleService: IdleService,
//         private dialog: MatDialog,
//         private _router: Router
//     ) {}

//     // -----------------------------------------------------------------------------------------------------
//     // @ Lifecycle hooks
//     // -----------------------------------------------------------------------------------------------------

//     /**
//      * On init - start idle service
//      */
//     ngOnInit(): void {
//         const hiddenPaths = [
//             '/confirmation-required',
//             '/forgot-password',
//             '/reset-password',
//             '/sign-in',
//             '/log-in',
//             '/sign-up',
//             '/sign-out',
//         ];

//         // this.isDisplay = !hiddenPaths.includes(this._router['url']);

//         this.isDisplay = !hiddenPaths.includes(this._router.url);

//         // Hide it on the first NavigationEnd event
//         this._router.events
//             .pipe(
//                 filter((event) => event instanceof NavigationEnd),
//                 takeUntil(this._unsubscribeAll)
//             )
//             // .subscribe((resp) => {
//             //     this.isDisplay = !hiddenPaths.includes(resp['url']);
//             // });
//             .subscribe((event: NavigationEnd) => {
//                 this.isDisplay = !hiddenPaths.includes(event.url);

//                 // If the new route is a hidden path, close the idle pop-up
//                 if (!this.isDisplay) {
//                     this.dialogRef?.close();
//                     this.idleService.stopWatching();
//                 }
//             });

//         this.idleSubscription = this.idleService.idleState.subscribe(
//             (isIdle) => {
//                 if (isIdle && this.isDisplay) {
//                     this.openIdleDialog(); // Open pop-up when user is idle.
//                 } else {
//                     this.dialogRef?.close(); // Close pop-up when user is active again.

//                     //here reset timer
//                 }
//             }
//         );
//     }

//     /**
//      * On destory - clean up subscriptions
//      */
//     ngOnDestroy(): void {
//         if (this.idleSubscription) {
//             this.idleSubscription.unsubscribe();
//         }
//     }

//     // openIdleDialog() {
//     //     if (!this.dialogRef || !this.dialogRef.componentInstance) {
//     //         this.dialogRef = this.dialog.open(DialogIdleComponent, {
//     //             width: '400px',
//     //             disableClose: true,
//     //         });

//     //         this.dialogRef.afterClosed().subscribe(() => {
//     //             this.idleService.resetTimer(); // Reset idle timer when pop-up closes
//     //         });
//     //     }
//     // }

//     openIdleDialog() {
//         if (!this.dialog.openDialogs.length) {
//             this.dialogRef = this.dialog.open(DialogIdleComponent, {
//                 width: '400px',
//                 disableClose: true,
//             });

//             this.dialogRef.afterClosed().subscribe(() => {
//                 this.idleService.resetTimer();
//             });
//         }
//     }

//     // -----------------------------------------------------------------------------------------------------
//     // @ Public methods
//     // -----------------------------------------------------------------------------------------------------
// }

// export function initializeApp(appConfig: AppConfig) {
//     return () => appConfig.load();
// }

// Imports
import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { Subject, filter, takeUntil } from 'rxjs';
import { AppConfig } from './config/service.config';
import { ExportJobsWidgetComponent } from './core/export-jobs/export-jobs-widget.component';
import { DialogIdleComponent } from './modules/auth/dialog-idle/dialog-idle.component';
import {
    IdleService,
    IdleSessionState,
} from './modules/auth/dialog-idle/idle.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [
        RouterOutlet,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ExportJobsWidgetComponent,
    ],
})
export class AppComponent implements OnInit, OnDestroy {
    private readonly _unsubscribeAll = new Subject<void>();
    private readonly _hiddenPaths = [
        '/confirmation-required',
        '/forgot-password',
        '/reset-password',
        '/sign-in',
        '/log-in',
        '/sign-up',
        '/sign-out',
    ];
    private _dialogRef?: MatDialogRef<DialogIdleComponent>;
    private _loggingOut = false;

    isDisplay: boolean = true;

    // -----------------------------------------------------------------------------------------------------
    // @ Constructor
    // -----------------------------------------------------------------------------------------------------

    constructor(
        private readonly idleService: IdleService,
        private readonly dialog: MatDialog,
        private readonly _router: Router,
        private readonly _authService: AuthService
    ) {}

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init - start idle service
     */
    ngOnInit(): void {
        this.updateSessionTracking(this._router.url);

        this._router.events
            .pipe(
                filter((event) => event instanceof NavigationEnd),
                takeUntil(this._unsubscribeAll)
            )
            .subscribe((event: NavigationEnd) => {
                this.updateSessionTracking(event.urlAfterRedirects);
            });

        this.idleService.state$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((state) => this.handleIdleState(state));
    }

    /**
     * On destory - clean up subscriptions
     */
    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
        this.idleService.stopWatching();
    }

    private updateSessionTracking(url: string): void {
        this.isDisplay = !this._hiddenPaths.some((path) =>
            url.startsWith(path)
        );

        if (this.isDisplay && !!this._authService.accessToken) {
            this._loggingOut = false;
            this.idleService.startWatching();
            return;
        }

        this._dialogRef?.close();
        this._dialogRef = undefined;
        this.idleService.stopWatching();
    }

    private handleIdleState(state: IdleSessionState): void {
        if (!this.isDisplay) {
            return;
        }

        // A logout in another tab removes the shared token before this state is
        // emitted. Handle expiration first so this tab cannot remain on a
        // protected screen with a stale in-memory authenticated state.
        if (state.status === 'expired') {
            this.logoutExpiredSession();
            return;
        }

        if (!this._authService.accessToken) {
            return;
        }

        if (state.status === 'warning' && state.logoutAt) {
            this.openIdleDialog(state.logoutAt);
            return;
        }

        if (state.status === 'active') {
            this._dialogRef?.close('activity-in-another-tab');
            this._dialogRef = undefined;
            return;
        }
    }

    private openIdleDialog(logoutAt: number): void {
        if (this._dialogRef) {
            return;
        }

        this._dialogRef = this.dialog.open(DialogIdleComponent, {
            width: '430px',
            maxWidth: 'calc(100vw - 32px)',
            disableClose: true,
            autoFocus: false,
            restoreFocus: true,
            panelClass: 'idle-session-dialog-panel',
            data: { logoutAt },
        });

        this._dialogRef
            .afterClosed()
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(() => {
                this._dialogRef = undefined;
            });
    }

    private logoutExpiredSession(): void {
        if (this._loggingOut) {
            return;
        }

        this._loggingOut = true;
        this._dialogRef?.close('expired');
        this._dialogRef = undefined;

        this._authService.signOut().subscribe(() => {
            this.idleService.clearSession();
            void this._router.navigate(['/sign-in'], {
                queryParams: { reason: 'session-expired' },
                replaceUrl: true,
            });
        });
    }
}

export function initializeApp(appConfig: AppConfig) {
    return () => appConfig.load();
}
